/* eslint-disable no-underscore-dangle */
import { addEvent, removeEvent, triggerEvent } from '../utils/events';

require('custom-event-polyfill');

const ESCAPE_KEYCODE = 27;
const TABINDEX_VALUE = -1;
const TRANSITION_DURATION = 300;
const Default = {
  customWidth: false,
  direction: 'right',
  positiveTrigger: '.js-drawer-positive',
  negativeTrigger: '.js-drawer-close',
};
const ClassName = {
  OPEN: 'drawer--is-open',
};
const Selector = {
  CONTENT: '.drawer__panel',
  DATA_TOGGLE: '[data-toggle="drawer"]',
  DATA_DISMISS: '[data-dismiss="drawer"]',
};
export class Drawer {

  /**
   * @param  {Dom}    drawer     drawer DOM object
   * @param  {Object} config     config for drawer
   */
  constructor(drawer, config) {
    this._config = this.getConfig(config);
    this._element = drawer;
    this._content = this._element.querySelector(Selector.CONTENT);
    if (this._config.trigger) {
      this._trigger = document.querySelector(this._config.trigger);
    }
    this._isOpen = false;
    this._hasCustomWidth = false;

    // Bind the context with the events
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.negative = this.negative.bind(this);
    this.positive = this.positive.bind(this);
    this.checkEscapeKey = this.checkEscapeKey.bind(this);
    this.backdropClick = this.backdropClick.bind(this);

    if (!this.isEverythingOk()) {
      return;
    }

    // Initialize drawer
    this.init();
  }

  getConfig(config) {
    config = {
      ...Default,
      ...config,
    };

    return config;
  }

  init() {
    if (this._config.customWidth) {
      this.handleCustomWidth();
    }
    this.bindButtons();
    if (this._trigger) {
      addEvent(this._trigger, 'click', (this._config.tabbed) ? this.toggle.bind(this) : this.open.bind(this));
    }
    this.handleAccessibility();
  }

  bindButtons() {
    for (const closeButton of this._element.querySelectorAll(this._config.negativeTrigger)) {
      addEvent(closeButton, 'click', this.negative);
    }
    for (const positiveButton of this._element.querySelectorAll(this._config.positiveTrigger)) {
      addEvent(positiveButton, 'click', this.positive);
    }
  }

  handleAccessibility() {
    if (this._isOpen === true) {
      this._element.setAttribute('aria-hidden', 'false');
      this._content.setAttribute('aria-expanded', 'true');
      this._content.setAttribute('tabindex', TABINDEX_VALUE);
      /**
       *----
        [Come back to: Steven] Figure out why right aligned doesnt transition without
        setTimeout
       *----
       */
      setTimeout(() => {
        this._content.focus();
      }, TRANSITION_DURATION);
    } else {
      this._element.setAttribute('aria-hidden', 'true');
      this._content.setAttribute('aria-expanded', 'false');
      this._content.removeAttribute('tabindex');
      if (this._trigger) {
        this._trigger.focus();
      }
      setTimeout(() => {
        if (this._config.tabbed && this._trigger) {
          this._trigger.querySelector('.btn').blur();
        }
      }, TRANSITION_DURATION);
    }
  }

  /**
   *----
    [Come back to: Steven] Look at a way to get this to work responively, px/rem
    values not likely to be an option
   *----
   */

  handleCustomWidth() {
    this._element.style.width = this._config.customWidth;
    this._element.style[this._config.direction] = `-${ this._config.customWidth }`;
    this._hasCustomWidth = true;
  }

  setDrawerDirection() {
    this._config.direction = (
        this._element.className.split(' ').some((cla) => /.*--left/.test(cla))) ?
        'left' :
        'right';
  }

  backdropClick(event) {
    if (event.target === this._element) {
      this.close();
    }
  }

  open() {
    if (!this._element.classList.contains(ClassName.OPEN)) {
      this._element.classList.add(ClassName.OPEN);
    }
    if (this._hasCustomWidth) {
      this._element.style[this._config.direction] = 0;
    }
    addEvent(document, 'keydown', this.checkEscapeKey);
    triggerEvent(this._element, 'show.commonui.drawer');
    this._isOpen = true;
    addEvent(this._element, 'click', this.backdropClick);
    this.handleAccessibility();
  }

  close() {
    if (this.hasCustomWidth) {
      this._element.style[this._elementDirection] = `-${ this.customWidth }`;
    }
    this._element.classList.remove(ClassName.OPEN);
    document.onkeydown = null;
    triggerEvent(this._element, 'hide.commonui.drawer');
    this._isOpen = false;
    removeEvent(this._element, 'click', this.backdropClick);
    this.handleAccessibility();
  }

  toggle() {
    return this._isOpen ? this.close() : this.open();
  }

  positive() {
    triggerEvent(this._element, 'positive.commonui.drawer');
    this.close();
  }

  negative() {
    triggerEvent(this._element, 'negative.commonui.drawer');
    this.close();
  }

  checkEscapeKey(evt) {
    if (evt && evt.keyCode === ESCAPE_KEYCODE) {
      this.negative();
    }
  }

  destroy() {
    this.close();
    if (this._trigger) {
      removeEvent(this._trigger, 'click', this.open);
    }
  }

  /* eslint-disable no-console */
  isEverythingOk() {
    if (!this._element) {
      console.warn('CommonUI - Drawer - No drawer contents found');
      return false;
    }
    if (this._config.customWidth &&
      !this._config.customWidth.match(/\d*\.?\d+(?:px|rem|%)?/i) &&
      typeof this._config.customWidth !== 'string'
    ) {
      console.warn(`CommonUI - Drawer - The value for customWidth must be a
        string and an xx(px|rem|%) value (where xx is a number).`);
      return false;
    }
    return true;
  }
  /* eslint-enable no-console */
}

/**
 * creates a new drawer instance
 * @param  {Object} config
 */
export default function initDrawer(selector, config = {}) {
  let drawer = null;
  if (typeof selector === 'string') {
    drawer = new Drawer(document.querySelector(selector), config);
  } else if (typeof selector === 'object') {
    drawer = new Drawer(selector, config);
  }
  return drawer;
}



// WEBPACK FOOTER //
// ./js/components/Drawer.js